export default __webpack_public_path__ + "static/media/C2_18_x_24.d7c8f376.jpg";